module.exports = __webpack_public_path__ + "img/animals_fox.9718328e.png";